import { useMutation } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { queryClient } from '@/api/react-query'
import { applicationQueryKey } from '@/api/financial/application/read-application'

export function useDeleteDocument(applicationKey: string) {
  return useMutation({
    mutationFn: async (documentKey: string) => {
      await httpClient('financial').delete('/v1/file/document', {
        params: { document_key: documentKey },
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: applicationQueryKey(applicationKey) })
    },
  })
}

export function useUploadDocument(applicationKey: string) {
  return useMutation({
    mutationFn: async ({
      type,
      file,
      personKey,
    }: {
      type: string
      file: File
      personKey: string
    }) => {
      const body = new FormData()
      body.append('file', file)
      await httpClient('financial').post('/v1/file/document', body, {
        params: { type, person_key: personKey },
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: applicationQueryKey(applicationKey) })
    },
  })
}
